export const TOKEN_PRICE = 0.000028; //ETH

export const PRESALE_TARGET_ADDRESS = "0xb6433157f6E71057f1d3552b75155B3a8c110632"; //"0x87b447a2fa71f035fD7f2F4a97E13904b03C54ef"